<template>
  <div class="app-content-wrapper">
    <div class="padding-top-32 top-box">
      <el-image :src="require('../../../assets/images/app.png')" />
      <div class="action">
        <p class="title">{{$t('message.settlement.restoreDetaileddeclaration')}}</p>
        <p class="description margin-top-5">{{$t('message.settlement.restoreDescription')}}<p>
        <div class="margin-top-15" v-permission="'settlement:declaration:upfile'">
          <el-button @click="openUploadModal" type="primary" size="small">{{$t('message.settlement.uploadFile')}}</el-button>
          <el-link
            class="download margin-left-40"
            type="primary"
            href="/static/template/restoreDetailedDeclarationTemplate.xlsx"
            :download="`${$t('message.settlement.restoreDetaileddeclaration')}.xlsx`">
            <i class="iconfont icon-Download"></i>
            {{$t('message.settlement.templateDownload')}}
          </el-link>
        </div>
      </div>
    </div>
    <div class="search-wrapper">
      <search-component ref="search"
                        :search-condition="searchCondition"
                        :is-judgment-time="true"
                        :hideFuzzySearch="true"
                        :fuzzySearchPlaceholder="fuzzySearchPlaceholder"
                        router-name="/settlement/declaration">
      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table :table-set="tableCondition"
                    :service-function="getList"
                    :first-parameters="getInitParams()"
                    ref="table"
                    router-name="/settlement/declaration">
      </custom-table>
    </div>
    <validation-modal ref="uploadModal"
                      width="750px"
                      :titleText="$t('message.settlement.restoreDetaileddeclaration')"
                      @refresh="onRefreshTable"
                      :default-function="uploadFile"
                      :validation-condition="uploadCondition">
                      <template>
                        <div class="upload-template">
                          <el-link
                            class="download"
                            type="primary"
                            href="/static/template/restoreDetailedDeclarationTemplate.xlsx"
                            :download="`${$t('message.settlement.restoreDetaileddeclaration')}.xlsx`">
                            <i class="iconfont icon-Download"></i>
                            {{$t('message.settlement.templateDownload')}}
                          </el-link>
                        </div>
                      </template>
    </validation-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import ValidationModal from '@/components/modal/base-modal/validation-modal.vue';
import { ShowWarningMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import { REQUIRED } from '@/components/validation/tool/validator';
import { getEnantiomericValue } from '@/utils/tools/constant';
import { getTodayParams, initToday } from '@/utils/tools/time';
import DeclarationService from '@/views/settlement/api/restore-detailed-declaration';
import { RestoreDetailedDeclarationStatus } from '@/views/settlement/status/settlement';

export default {
  components: {
    SearchComponent,
    CustomTable,
    ValidationModal,
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  data() {
    return {
      ...DeclarationService,
      fuzzySearchPlaceholder: `${this.$t('message.settlement.restoreDetaileddeclarationNumber')}`,
      searchCondition: [
        {
          key: ['startTime', 'endTime'],
          name: 'message.dispute.appealFileTime',
          defValue: initToday(),
          type: 'date_time',
        },
        {
          key: 'viewFlag',
          name: 'message.tableCommon.status',
          type: 'select',
          defValue: '',
          options: RestoreDetailedDeclarationStatus,
          isInternationalization: true,
        },
      ],
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.tableCommon.serialNumber' },
          key: 'serialNumber',
          type: 'serialNumber',
          itemWidth: '100px',
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.dispute.appealFileTime' },
          key: 'createTime',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.fileName' },
          key: 'fileName',
          type: 'click',
          subTableDisplays: [
            {
              type: 'download',
              textFunc: (row) => row.fileName,
              permissionCode: 'settlement:declaration:export',
              isDisplayFunc: (row) => !!row.filePath,
              func: (row) => {
                this.downloadFileByUrl({ url: row.filePath });
              },
            },
          ],
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.restoreDetaileddeclarationNumber' },
          key: 'id',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.count' },
          key: 'totalCount',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.successCount' },
          key: 'successCount',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.failedCount' },
          key: 'errorCount',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.status' },
          key: 'viewFlag',
          type: 'text',
          isInternationalization: true,
          isItemSettingsDisplay: false,
          textFunc: (row) => getEnantiomericValue(RestoreDetailedDeclarationStatus, row.viewFlag),
        },
        {
          titleBar: { type: 'operations', title: 'message.tableCommon.operation' },
          key: 'operations',
          type: 'operations',
          subTableDisplays: [
            // {
            //   type: 'text_button',
            //   textFunc: () => 'message.settlement.export',
            //   permissionCode: 'settlement:declaration:export',
            //   isDisplayFunc: (row) => !!row.filePath,
            //   func: (row) => {
            //     this.downloadFileByUrl({ url: row.filePath });
            //   },
            // },
            {
              type: 'text_button',
              textFunc: () => 'message.settlement.downloadFailedFile',
              permissionCode: 'settlement:declaration:downloadFailedFile',
              isDisplayFunc: (row) => !!row.errorFilePath,
              func: (row) => {
                this.downloadFileByUrl({ url: row.errorFilePath });
              },
            },
          ],
        },
      ],
      uploadCondition: [
        {
          key: 'appId',
          name: 'message.tableCommon.appName',
          type: 'select',
          defValue: '',
          isShowStar: true,
          rule: [REQUIRED],
          options: [],
          option: {
            label: 'appName',
            value: 'id',
          },
          itemWidth: '470px',
        },
        {
          key: 'fileName',
          name: 'message.settlement.uploadFile',
          type: 'upload_file',
          defValue: '',
          isShowStar: true,
          uploadRange: {
            fileSize: 100, // 100M
            uploadFileList: [],
            fileTypeRule: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            fileTypeRuleTips: this.$t('message.supportFileErrorTip', { type: '.xlsx' }),
            fileTypeRuleTipsShow: this.$t('message.supportFileTip', { type: 'xlsx' }),
          },
        },
      ],
    };
  },
  created() {
    this.getAppList().then((res) => {
      this.uploadCondition[0].options = res;
    });
  },
  methods: {
    openUploadModal() {
      this.$refs.uploadModal.openModal(true);
    },
    uploadFile(params) {
      if (!params.fileNameFile) {
        ShowWarningMessage(this.$t('message.emptyUploadFileTip'));
        return Promise.reject(new Error('请选择文件'));
      }
      const data = new FormData();
      data.append('upfile', params.fileNameFile);
      data.append('appId', params.appId);
      return this.uploadDeclarationFile(data);
    },
    onRefreshTable() {
      return this.$refs.table.refreshTable();
    },
    getInitParams() {
      const params = getTodayParams('startTime', 'endTime');
      return params;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.top-box {
  display: flex;
  align-items: center;
  margin-bottom: 25px;

  & > .el-image {
    width: 238px;
    height: 188px;
    margin-right: 10px;
    min-width: 238px;
  }

  .action {
    .title {
      font-size: 16px;
      font-family: Avenir-Heavy, Avenir;
      font-weight: 800;
      line-height: 28px;
      color: $color-text-primary;
    }
    .description {
      font-size: 14px;
      font-weight: normal;
      color: $color-text-primary;
      line-height: 21px;
    }
    .download {
      font-size: 14px;
      font-family: Avenir-Heavy, Avenir;
      font-weight: 800;
      color: $color-text-default-button;
      line-height: 32px;

      .iconfont {
        font-size: 14px;
      }
    }
  }
}
</style>

<style lang="scss">
@import '@/styles/variables.scss';

.upload-template {
  position: absolute;
  top: 123px;
  right: 30px;
  height: 32px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: Avenir-Heavy, Avenir;
  font-weight: 800;
  color: $color-text-default-button;

  .icon-Download {
    font-weight: 400;
    font-size: 14px;
  }
}
</style>
